const SHARE_APIS = {
    whatsappDesktop: (shareText, url) => `https://web.whatsapp.com/send?text=${shareText}`,
    whatsappPhone: (shareText, url) => `whatsapp://send?text=${shareText}%0A${url}`,
    fb: (shareText, url) => `https://www.facebook.com/share.php?u=${url}&quote=${shareText}`,
    twitter: (shareText, url) => `https://www.twitter.com/share?text=${shareText}%0A&url=${url}`,
    email: (shareText, url, title) => `mailto:?subject=${title}&body=${shareText}%0A${url}`,
    linkedIn: (shareText, url) => `https://www.linkedin.com/shareArticle?mini=true?summary=${shareText}&url=${url}`
};

export { SHARE_APIS };
//# sourceMappingURL=shareApis.js.map
